/*
 * This file exports configuration:
 *
 *  - jmespath json transforms for the data
 *
 *  - brand color
 *
 *  - logo url
 *
 */

const credentials = {

  scraper_feed: 'https://digitalwires.dpa-newslab.com/JAQ6UZbblsGQnfF9V7gw4cmBTF9If5CV/aufschaltung/au-clHKR1OcqP433eS1NS/feed/newsscreen.json',
  insight_feed: 'https://digitalwires.dpa-newslab.com/3oW9QB5peNOQcmpvc35O853BuB0GezSB/aufschaltung/au-clNDN37KE7BYFFntzj/feed/insight-eu-all.json'
}

const updateTimeString = function (appStart, item) {
  /*
       * item has to timestamps:
       *    - version_created (from the version_created property)
       *    - firstseen (when it was first seen by the Vue app)
       *
       * appStart is the timestamp when the app started
       */
  const ageSeconds = Math.floor(((new Date() - item.parsed_created) + 500) / 1000)
  const seenSeconds = Math.floor(((new Date() - item.firstseen) + 500) / 1000)
  const appAgeSeconds = Math.floor(((item.firstseen - appStart) + 500) / 1000)
  const secs = ageSeconds
  const mins = Math.floor((secs + 30) / 60)
  const hours = Math.floor((secs + 1800) / 3600)
  if ((seenSeconds < 100) && (appAgeSeconds > 20)) {
    return 'vor wenigen Sekunden'
  } else if (mins < 9) {
    return 'vor wenigen Minuten'
  } else if (mins < 33) {
    return 'vor ' + mins + ' Minuten'
  } else if (hours === 1) {
    return 'vor einer Stunde'
  } else if (hours < 5) {
    return 'vor ' + hours + ' Stunden'
  } else {
    return false
  }
}

let config = {

  slides: [

    {
      url: function () {
        return credentials.scraper_feed + '?' + Math.floor(new Date())
      },
      name: 'dpa-newsscreen',
      enabled: true,
      errorString: 'Fehler im Newsscreen-Feed',
      jmespath: `entries[? !(contains(headline,'Vorhersage für')) && 
                                    !(starts_with(headline,'Lotto')) ].{ 
            headline:  headline,
            tklass: [
                         { t: contains(headline,'Vorhersage für'),  c: 'wetter-slide' },
                         { t: starts_with(headline,'Lotto'), c: 'lotto-slide' },
                         { t: ( associations[0].renditions[0].width && 
                                associations[0].renditions[0].height &&
                                (ceil(associations[0].renditions[0].width) <= ceil(associations[0].renditions[0].height))), c: 'portrait-slide' },
                         { t: true, c: 'news' }
                    ][?t] | [0].c,
            urn: urn, 
            ressort: dpasubject_names[0], 
            article_html: article_html, 
            version_created: version_created,
            bg: { url: associations[0].renditions[0].url, creditline: "" } 
        }`
    }
  ],

  ticker: [

    {
      url: function () {
        return credentials.scraper_feed + '?' + Math.floor(new Date())
      },
      name: 'dpa-newsscreen',
      enabled: true,
      jmespath: `entries[? !(contains(headline,'Vorhersage für')) && 
                              !(starts_with(headline,'Lotto'))  ].{ 
        headline: headline, 
        urn: urn,
        version_created: version_created
      }`
    }

  ],

  css: {

    brand_color: '#afd699',
    /* full css background value */
    logo: {
      'landscape': 'url(../img/dpa-newslab-logo-240.png) center center no-repeat',
      'portrait': 'url(../img/dpa-newslab-logo-240-north.png) center center no-repeat'
    }
  },

  /* Time per slide in milliseconds */
  slide_time: 10500,
  /* Ticker in seconds */
  ticker_duration: 190,

  /* seconds between checking for new versions by fetching git.json */
  checkVersionInterval: 5 * 60000,

  /* seconds between reloading the data feeds */
  reloadInterval: 60000,

  /*
  d - . .
  p . - - .
  a . -

  tap / click this code on the logo to get the tech detail overview
*/

  updateTimeString: updateTimeString,

  solution: '-...--..-',
  // solution: '.'

  force_fullscreen: true

}

export default config
